import { BaseComponent } from '../base-component/base-component';
import { PaymentOrderItemData } from '../order-confirmation/order-completion.interface';
import { ProductCardData } from '../product-card/product-card-display';
import { TemplateResult, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { isProfessional } from '../../common/utils/product-util';

export enum LabelSize {
  small = 'small',
  large = 'large'
}

@customElement('mhecomm-subscription-length')
export class SubscriptionLength extends BaseComponent {
  /**
   * The size of the label, either 'small' or 'large'.
   */
  @property()
  labelSize = LabelSize.small;

  /**
   * A JSON String in the format of a product object that contains duration details.
   */
  @property({type: Object})
  product?: PaymentOrderItemData | ProductCardData;

  renderComp(): TemplateResult {
    if (
      !isProfessional(this.product?.businessUnit ?? '')
      || !this.product?.duration
      || !this.product?.durationPeriod) {
      return html``;
    }

    return html`
      <span>
        <span class="${this.labelSize === LabelSize.small ? 'fs-6 fw-semibold' : 'fw-bold'}">
          Subscription Length: 
        </span>
        <span data-automation-id=${this.getAutomationId()}>
         ${this.product.duration} ${this.product.durationPeriod}${this.product.duration > 1 ? 's' : ''}
        </span>
      </span>
    `;
  }

  /**
   * Returns the automation id for the subscription length.
   */
  getAutomationId(): string {
    const prefix = 'subscription-length';

    if (this.product && 'isbn10' in this.product) {
      return `${prefix}-${this.product.isbn10}`;
    }

    if (this.product && 'isbn' in this.product) {
      return `${prefix}-${this.product.isbn}`;
    }

    return prefix;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-subscription-length': SubscriptionLength;
  }
}
